import { h } from "@stencil/core";
import { PianoTerm } from "../types";

const PlanHeader = ({ term }: { term: PianoTerm }) => {
  return (
    <div class="plan-header">
      <p class="plan-selected">Your plan:{" "}
        <strong>{term.resource.name}</strong>
      </p>
      <p>
        {term.description && <span class="original-price">{term.description} {term.chargeCurrency}{" "}</span>}
        <strong>{term.billingPlanTable[0].priceValue} {term.chargeCurrency}</strong> per {term.billingPlanTable[0].period}
      </p>
    </div>
  );
};

export default PlanHeader;
